var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video flex flex-column"},[_c('dark-header'),_c('div',{staticClass:"flex flex-between player-container"},[(!_vm.loading)?_c('player',{staticClass:"flex-item player",attrs:{"video":_vm.video}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }